import { render, staticRenderFns } from "./DealerInfo.vue?vue&type=template&id=10ffd170&"
import script from "./DealerInfo.vue?vue&type=script&lang=ts&"
export * from "./DealerInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports